import { useEffect, useState } from "react";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const IndustryProfiles = () => {
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchProfiles = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/marketplace/industry/profiles/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        });

        setProfiles(res.data || []);
      } catch (error) {
        console.error("Error fetching industry profiles:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProfiles();
  }, []);

  if (loading) {
    return (
      <div className="text-center py-10 text-gray-500">
        Loading industry profiles...
      </div>
    );
  }

  return (
  <div className="max-w-md mx-auto p-6">
  <h2 className="text-lg font-semibold text-gray-900 mb-1">Industry Profiles</h2>

  <div className="flex flex-col gap-4">
    {profiles.map((profile, index) => (
      <div
        key={profile.id || index}
        className="flex items-center justify-between bg-white p-4 rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-all duration-200"
      >
        {/* LEFT SIDE */}
        <div className="flex items-center gap-4">
          {/* Logo Circle */}
          <div className="w-12 h-12 rounded-xl   flex items-center justify-center">
            <img
              src={profile?.industry_logo}
              alt={profile?.industry_name}
              className="w-full h-full rounded-lg object-cover"
            />
          </div>

          {/* Info */}
          <div>
            <p className="font-semibold text-sm text-gray-900">
              {profile.industry_name}
            </p>

            <p className="text-gray-500 text-xs mt-0.5">
              {profile.contact}
              {/* zaineb.aloui@usherbrooke.ca */}
            </p>

            <p className="text-gray-400 text-[11px] mt-0.5">
              {profile.address?.slice(0, 40)}...
            </p>
          </div>
        </div>

        {/* BUTTON */}
        <button className="text-xs px-4 py-2 bg-[#0f6abf] text-white font-medium rounded-lg hover:bg-[#0a5ca8] transition-colors shadow-sm">
          Collaborate
        </button>
      </div>
    ))}
  </div>
</div>
  );
};

export default IndustryProfiles;